// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Logs Page */
.admin-logs-page .dashboard-body {
  padding-bottom: 2rem;
}

.admin-logs-hero__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
}

.admin-logs-section {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.admin-logs-header {
  padding: 1.25rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.admin-logs__title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text, #1e293b);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.admin-logs__title i {
  color: #0f766e;
}

.admin-logs-filters {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
}

.admin-logs-filters__row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-end;
}

.admin-logs-filter {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-muted, #64748b);
}

.admin-logs-filter input {
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  min-width: 140px;
}

.admin-logs-filter input:focus {
  outline: none;
  border-color: #0f766e;
}

.admin-logs-select {
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  min-width: 80px;
  background: #fff;
}

.admin-logs-btn-apply {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.admin-logs-btn-apply:hover {
  opacity: 0.95;
}

.admin-logs-error {
  padding: 1rem 1.5rem;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.admin-logs-loading,
.admin-logs-empty {
  padding: 3rem 1.5rem;
  text-align: center;
  color: var(--text-muted, #64748b);
}

.admin-logs-loading i,
.admin-logs-empty i {
  font-size: 2rem;
  display: block;
  margin-bottom: 0.75rem;
  opacity: 0.6;
}

.admin-logs-table-wrap {
  overflow-x: auto;
}

.admin-logs-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.admin-logs-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #f0f9ff;
  background: rgba(15, 23, 42, 0.85);
  white-space: nowrap;
}

.admin-logs-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text, #1e293b);
}

.admin-logs-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.admin-logs-table tbody tr:hover {
  background: rgba(15, 118, 110, 0.06) !important;
}

.admin-logs-admin {
  display: block;
  font-weight: 500;
}

.admin-logs-type {
  font-size: 0.75rem;
  color: var(--text-muted, #64748b);
}

.admin-logs-method {
  display: inline-block;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 700;
}

.admin-logs-method--get {
  background: #dcfce7;
  color: #166534;
}

.admin-logs-method--post {
  background: #dbeafe;
  color: #1e40af;
}

.admin-logs-method--put,
.admin-logs-method--patch {
  background: #fef3c7;
  color: #b45309;
}

.admin-logs-method--delete {
  background: #fee2e2;
  color: #b91c1c;
}

.admin-logs-route {
  font-family: monospace;
  font-size: 0.8rem;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-logs-action {
  font-size: 0.85rem;
  font-weight: 500;
  max-width: 220px;
}

.admin-logs-details {
  font-size: 0.8rem;
  color: var(--text-muted, #64748b);
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-logs-status {
  display: inline-block;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
}

.admin-logs-status--success {
  background: #dcfce7;
  color: #166534;
}

.admin-logs-status--error {
  background: #fee2e2;
  color: #b91c1c;
}

.admin-logs-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.admin-logs-pagination__info {
  font-size: 0.875rem;
  color: var(--text-muted, #64748b);
}

.admin-logs-pagination__buttons {
  display: flex;
  gap: 0.5rem;
}

.admin-logs-pagination__btn {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: inherit;
  color: #0f766e;
  background: #fff;
  border: 1px solid #0f766e;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.admin-logs-pagination__btn:hover:not(:disabled) {
  background: #0f766e;
  color: #fff;
}

.admin-logs-pagination__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .admin-logs-filters__row {
    /* flex-direction: column; */
  }

  .admin-logs-filter input {
    min-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Admin/AdminLogsPage.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Admin Logs Page */\n.admin-logs-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.admin-logs-hero__icon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.4);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4rem;\n}\n\n.admin-logs-section {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.admin-logs-header {\n  padding: 1.25rem 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.admin-logs__title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.admin-logs__title i {\n  color: #0f766e;\n}\n\n.admin-logs-filters {\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid #e2e8f0;\n  background: #fff;\n}\n\n.admin-logs-filters__row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  align-items: flex-end;\n}\n\n.admin-logs-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--text-muted, #64748b);\n}\n\n.admin-logs-filter input {\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  min-width: 140px;\n}\n\n.admin-logs-filter input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.admin-logs-select {\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  min-width: 80px;\n  background: #fff;\n}\n\n.admin-logs-btn-apply {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.admin-logs-btn-apply:hover {\n  opacity: 0.95;\n}\n\n.admin-logs-error {\n  padding: 1rem 1.5rem;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.admin-logs-loading,\n.admin-logs-empty {\n  padding: 3rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted, #64748b);\n}\n\n.admin-logs-loading i,\n.admin-logs-empty i {\n  font-size: 2rem;\n  display: block;\n  margin-bottom: 0.75rem;\n  opacity: 0.6;\n}\n\n.admin-logs-table-wrap {\n  overflow-x: auto;\n}\n\n.admin-logs-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.admin-logs-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #f0f9ff;\n  background: rgba(15, 23, 42, 0.85);\n  white-space: nowrap;\n}\n\n.admin-logs-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text, #1e293b);\n}\n\n.admin-logs-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.admin-logs-table tbody tr:hover {\n  background: rgba(15, 118, 110, 0.06) !important;\n}\n\n.admin-logs-admin {\n  display: block;\n  font-weight: 500;\n}\n\n.admin-logs-type {\n  font-size: 0.75rem;\n  color: var(--text-muted, #64748b);\n}\n\n.admin-logs-method {\n  display: inline-block;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.admin-logs-method--get {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.admin-logs-method--post {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.admin-logs-method--put,\n.admin-logs-method--patch {\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.admin-logs-method--delete {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.admin-logs-route {\n  font-family: monospace;\n  font-size: 0.8rem;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-logs-action {\n  font-size: 0.85rem;\n  font-weight: 500;\n  max-width: 220px;\n}\n\n.admin-logs-details {\n  font-size: 0.8rem;\n  color: var(--text-muted, #64748b);\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-logs-status {\n  display: inline-block;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.admin-logs-status--success {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.admin-logs-status--error {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.admin-logs-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.admin-logs-pagination__info {\n  font-size: 0.875rem;\n  color: var(--text-muted, #64748b);\n}\n\n.admin-logs-pagination__buttons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.admin-logs-pagination__btn {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #0f766e;\n  background: #fff;\n  border: 1px solid #0f766e;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-logs-pagination__btn:hover:not(:disabled) {\n  background: #0f766e;\n  color: #fff;\n}\n\n.admin-logs-pagination__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n@media (max-width: 900px) {\n  .admin-logs-filters__row {\n    /* flex-direction: column; */\n  }\n\n  .admin-logs-filter input {\n    min-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
